import script from "./ExternalPaymentView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalPaymentView.vue?vue&type=script&setup=true&lang=js"

import "./ExternalPaymentView.vue?vue&type=style&index=0&id=4f6e97b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6e97b8"]])

export default __exports__